import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createBootstrap } from 'bootstrap-vue-next'
import App from './App.vue'
import router from './router'
import * as Sentry from "@sentry/vue";
import { VueDatePicker } from '@vuepic/vue-datepicker';
import Vue3Dropzone from "@jaxtheprime/vue3-dropzone";
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import { vDraggable } from 'vue-draggable-plus'

// import * as zod from 'zod';  //to uncomment when move to zod4

import 'bootstrap/dist/js/bootstrap';
// import 'bootstrap/dist/css/bootstrap.css' // replaced by custom.scss

import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@vuepic/vue-datepicker/dist/main.css';
import './css/vue-datepicker.css';

import "@jaxtheprime/vue3-dropzone/dist/style.css";

import 'quill/dist/quill.snow.css'
// import "@windmillcode/quill-emoji/quill-emoji.css";
import 'quill-resize-module/dist/resize.css'

import "/node_modules/flag-icons/css/flag-icons.min.css";

import './css/custom.scss';
import './css/style.css';

const pinia = createPinia()
const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://5714d95f8588d45969a32be4652e0afe@o342868.ingest.us.sentry.io/4510229484797952",
  environment: import.meta.env.VITE_ENVIRONMENT,
  enabled: import.meta.env.VITE_ENVIRONMENT !== 'local',
  sendDefaultPii: true,
  integrations: [
    Sentry.captureConsoleIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false
    }),
    Sentry.zodErrorsIntegration(),
    Sentry.browserSessionIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 0%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(pinia)
app.use(router)
app.component('VueDatePicker', VueDatePicker)
app.component('Vue3Dropzone', Vue3Dropzone)
app.directive('draggable', vDraggable)
app.use(createBootstrap())

dayjs.locale('fr');
// zod.config(zod.locales.fr()); //to uncomment when move to zod4

app.directive('upper-case', (el: HTMLInputElement | HTMLTextAreaElement, binding: { value?: boolean }) => {
  if (binding?.value) {
    const sourceValue = el.value;
    const newValue = sourceValue.toUpperCase();

    if (sourceValue !== newValue) {
      el.value = newValue;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
})

app.mount('#app')
